import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { message, Spin } from "antd";
import useLogin from "../../CustomHooks/useLogin";
import loginSlice from "../../redux/loginSlice";

const MSAuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { saveLoginStatus, removeLoginStatus } = useLogin();
    const isLogined = useSelector((state) => state.loginReducer.isLogined);
    const [loading, setLoading] = useState(true);
    const calledRef = React.useRef(false);

    useEffect(() => {
        // Nếu đã đăng nhập rồi thì chuyển ngay về trang chủ, không xác thực lại
        if (isLogined) {
            navigate("/");
            return;
        }

        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");

        if (!code) {
            message.error("Không tìm thấy mã xác thực từ Microsoft.");
            setLoading(false);
            navigate("/");
            return;
        }

        // Đảm bảo API chỉ gọi đúng 1 lần duy nhất cho mỗi mã code
        if (calledRef.current) {
            return;
        }
        calledRef.current = true;

        const verifyAuthCode = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_DOMAIN}/microsoft_graph_api/check_ms_auth_code`,
                    { code },
                    { withCredentials: true }
                );

                if (response.data && response.data.code === 200) {
                    saveLoginStatus("1");
                    localStorage.setItem("loginMethod", "microsoft");
                    dispatch(
                        loginSlice.actions.setWebrtc({ webrtc: response.data.agents[0].webrtc })
                    );
                    dispatch(loginSlice.actions.setUser({ user: response.data }));
                    message.success("Đăng nhập Microsoft thành công!");
                    navigate("/");
                } else {
                    removeLoginStatus();
                    message.error(response.data.message || "Đăng nhập thất bại.");
                    navigate("/");
                }
            } catch (error) {
                console.error("[MSAuthCallback]: error", error);
                removeLoginStatus();
                if (error.response && error.response.data && error.response.data.message) {
                    message.error(error.response.data.message);
                } else {
                    message.error("Lỗi kết nối đến hệ thống xác thực.");
                }
                navigate("/");
            } finally {
                setLoading(false);
            }
        };

        verifyAuthCode();
    }, [location, navigate, dispatch, saveLoginStatus, removeLoginStatus, isLogined]);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100%" }}>
            {loading ? (
                <div style={{ textAlign: "center" }}>
                    <Spin size="large" />
                    <p style={{ marginTop: 16 }}>Đang xác thực tài khoản Microsoft...</p>
                </div>
            ) : (
                <p>Đang chuyển hướng...</p>
            )}
        </div>
    );
};

export default MSAuthCallback;
